// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"fd065d66","703":"d9d4f55a","787":"547e1a85","925":"c11e04af"}[chunkId] + ".chunk.js";
};